import React from "react";

const Marquee = ({ logos = [] }) => {
  const items = [...logos, ...logos];
  return (
    <div className="relative w-full overflow-hidden py-12 md:py-14 border-y border-ahm-teal/10" data-testid="clients-marquee">
      <div className="marquee-track items-center gap-16 md:gap-20 px-6">
        {items.map((l, i) => (
          <div key={`${l.id || i}-${i}`} className="flex items-center justify-center min-w-[180px] md:min-w-[220px]">
            <img
              src={l.logo}
              alt={l.name || ""}
              loading="lazy"
              className="h-16 md:h-20 max-w-[220px] md:max-w-[260px] object-contain transition-transform duration-500 hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
